import { Backdrop, CircularProgress } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetSingleByIdTranscationTotalQuery } from "src/services/transcationService";
import { LOGIN_PAGE_LOGO } from "src/utils/constants";

const tableHead = "border-r border-slate-900 py-1 ";
const tableCell = "border-r border-slate-900 p-[5px] text-center";

const ReceiptDownload = () => {
  const { id } = useParams();
  const [receiptData, setReceiptData] = useState<any>();
  // **** Services
  const { data, isFetching, isLoading } =
    useGetSingleByIdTranscationTotalQuery(id);

  // **** Use Effect for RECEIPT
  useEffect(() => {
    if (!isFetching && !isLoading) {
      setReceiptData(data?.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching, isLoading, data]);

  if (isFetching || isLoading) {
    return (
      <Backdrop open={true}>
        <CircularProgress />
      </Backdrop>
    );
  }
  return (
    <>
      <div className="bg-slate-500 mx-4  h-[100vh]">
        <div className="bg-white   h-[100vh] mx-auto my-auto  text-[14px]">
          <div className=" border border-black ">
            <div className="border-b border-black px-2">
              <div className="flex justify-between">
                <div>
                  <img
                    src={LOGIN_PAGE_LOGO}
                    className="h-20 w-48 w-half"
                    alt="logo"
                  />
                </div>
                <div className="">
                  <p className="  ">
                    {" "}
                    Order No: {receiptData?.orderNumber || "-"}
                  </p>
                  <p className="">
                    Subject To Indore Jurisdiction Commerce Billing B-1,Block-
                    C, 2nd Floor, Navlakha Square, B.C.M City, Navlakha Madhya
                    Pradesh, 452001, India State Code GSTIN 4398573987, PAN
                    375347854593
                  </p>
                </div>
              </div>
              <div className="flex justify-between my-2">
                <p>Order No: {receiptData?.orderNumber} </p>
                <div className="flex gap-2">
                  Date & Time:
                  <p>
                    {moment(receiptData?.createdAt).format("DD-MM-YYYY") || "-"}
                  </p>
                  <p>
                    {moment(receiptData?.createdAt).format("hh:mm A") || "-"}
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-10 px-2 border-b border-slate-900">
              {/* Student Information */}
              <div className="col-span-6 py-3">
                <p className="font-extrabold text-[16px] mb-3">
                  Student Information -
                </p>

                <div className="space-y-2 text-[14px] text-slate-800">
                  <div className="flex">
                    <p className="font-bold min-w-[130px]">Name:</p>
                    <p>{receiptData?.name || "-"}</p>
                  </div>
                  <div className="flex">
                    <p className="font-bold min-w-[130px]">Mobile Number:</p>
                    <p>{receiptData?.mobile || "-"}</p>
                  </div>
                  <div className="flex">
                    <p className="font-bold min-w-[130px]">Email:</p>
                    <p>{receiptData?.email || "-"}</p>
                  </div>
                </div>
              </div>

              {/* Delivery Address */}
              <div className="col-span-5 pt-3 pb-5 border-l pl-4 border-slate-900">
                <p className="font-extrabold text-[16px] mb-3">
                  Delivery Address
                </p>

                <div className="space-y-2 text-[14px] text-slate-800">
                  <div className="flex">
                    <p className="font-bold min-w-[130px]">Address:</p>
                    <p>{receiptData?.address || "-"}</p>
                  </div>
                  <div className="flex">
                    <p className="font-bold min-w-[130px]">City:</p>
                    <p>{receiptData?.city || "-"}</p>
                  </div>
                  <div className="flex">
                    <p className="font-bold min-w-[130px]">State:</p>
                    <p>{receiptData?.state || "-"}</p>
                  </div>
                  <div className="flex">
                    <p className="font-bold min-w-[130px]">Pincode:</p>
                    <p>{receiptData?.pincode || "-"}</p>
                  </div>
                </div>
              </div>
            </div>
            {receiptData?.products?.length > 0 && (
              <div className=" mt-4">
                <p className="font-bold text-[16px] mb-2">Products</p>
                <table width="100%" className="border border-black">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className={tableHead}>Product Name</th>
                      <th className={tableHead}>Quantity</th>
                      <th className={tableHead}>Price</th>
                      <th className={tableHead}>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {receiptData.products.map((product: any, index: number) => (
                      <tr key={index} className="border-t border-black">
                        <td className={tableCell}>
                          {product?.productName || "-"}
                        </td>
                        <td className={tableCell}>
                          {product?.quantity || "-"}
                        </td>
                        <td className={tableCell}>₹ {product?.price || "-"}</td>
                        <td className={tableCell}>
                          ₹ {product?.price * product?.quantity || "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <table width="100%">
              <tbody>
                <tr className="border-b border-black">
                  <td className="w-1/3 py-2 font-bold pl-2">Books</td>
                  <td className="border-l border-black pl-2 capitalize">
                    {receiptData?.bookIssued
                      ?.filter((book: any) => book?.isIssued)
                      ?.map((book: any) => book?.bookName || "-")
                      ?.join(", ") || "-"}
                  </td>
                </tr>
                <tr className="border-b border-black">
                  <td className="w-1/3 font-bold py-2 pl-2">Delivery Mode</td>
                  <td className="border-l border-black pl-2 capitalize">
                    {receiptData?.delivery || "-"}
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="w-1/2 mt-5 border border-black">
              <tbody>
                <tr className="border-b border-black">
                  <td className={`${tableCell} font-bold`}>
                    Total Before Discount
                  </td>
                  <td className={tableCell}>
                    ₹ {receiptData?.orderTotal || 0}
                  </td>
                </tr>
                <tr className="border-b border-black">
                  <td className={`${tableCell} font-bold`}>Discount</td>
                  <td className={tableCell}>
                    {receiptData?.discountValue || "-"} (
                    {receiptData?.calculatedDisAmt || 0})
                  </td>
                </tr>
                <tr className="border-b border-black">
                  <td className={`${tableCell} font-bold`}>
                    Total After Discount
                  </td>
                  <td className={tableCell}>
                    ₹ {receiptData?.amtAfterDiscount || 0}
                  </td>
                </tr>
                <tr className="border-b border-black">
                  <td className={`${tableCell} font-bold`}>
                    Courier Charges
                  </td>
                  <td className={tableCell}>
                    ₹ {receiptData?.courierCharges || 0}
                  </td>
                </tr>
                <tr className="border-b border-black">
                  <td className={`${tableCell} font-bold`}>Total Payable</td>
                  <td className={tableCell}>
                    ₹ {receiptData?.totalPayable || 0}
                  </td>
                </tr>
                <tr className="border-b border-black">
                  <td className={`${tableCell} font-bold`}>
                    Received Amount
                  </td>
                  <td className={tableCell}>
                    ₹ {receiptData?.receivedAmt || 0}
                  </td>
                </tr>
                <tr className="border-b border-black">
                  <td className={`${tableCell} font-bold`}>Advance Used</td>
                  <td className={tableCell}>
                    ₹ {receiptData?.adjustAmount || 0}
                  </td>
                </tr>
                <tr>
                  <td className={`${tableCell} font-bold`}>Due</td>
                  <td className={tableCell}>₹ {receiptData?.dueAmt || 0}</td>
                </tr>
              </tbody>
            </table>

            <div className="flex justify-between  mt-10 mb-20 px">
              <p className="font-semibold text-[12px] w-1/2">
                This Is System Generated Receipt/Invoice Hence No Signature Or
                Stamp Is Required
              </p>
              <p className="text-[14px]0">Autorized Signatory</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceiptDownload;
